import { render, staticRenderFns } from "./medicalTree.vue?vue&type=template&id=4fb73352"
import script from "./medicalTree.vue?vue&type=script&lang=js"
export * from "./medicalTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports